module.exports = __webpack_public_path__ + "static/media/new-arrivals.706cf9a6.svg";